import { Suspense, useEffect, useState } from "react";
import {
  TableFilters,
  TableFiltersState,
} from "../../../../common/components/ui/table/TableFilters";
import Loading from "../../../../common/components/ui/loading/Loading";
import GenericTable from "../../../../common/components/ui/table/GenericTable";
import TableFooter from "../../../../common/components/ui/table/TableFooter";
import { getCategories } from "../../../../common/services/purchaseCategory.api";
import { IPurchaseCategory } from "../../../../types/purchaseCategory.type";
import ModalCreateCategory from "../modals/CreatePurchaseCategory";

function TableCategory() {
  const [page, setPage] = useState<number>(1);
  const [data, setData] = useState({ itemsPerPage: 10, totalItems: 0 });
  const [categories, setCategories] = useState<IPurchaseCategory[]>([]);
  const [filters, setFilters] = useState<TableFiltersState>({
    search: "",
    status: [],
  });
  const EMPTY_ACTION = { eventName: "", data: undefined };
  const [action, setAction] = useState<{ eventName: string; data?: unknown }>(
    EMPTY_ACTION
  );

  const [isLoading, setIsLoading] = useState(false);
  const isAction = (eventName: string) => action.eventName === eventName;

  const cleanActionData = () => {
    handleSearch(filters);
    setAction(EMPTY_ACTION);
  };

  const handleSearch = ({ search, status }) => {
    const newState = Object.assign({}, filters, { search, status });
    setFilters(newState);
  };

  useEffect(() => {
    async function loadCategories() {
      setIsLoading(true);
      const result = await getCategories({ ...filters, page });
      setData({
        itemsPerPage: data.itemsPerPage,
        totalItems: result.totalItems,
      });
      setCategories(result.data);
      setIsLoading(false);
    }
    loadCategories();
  }, [data.itemsPerPage, filters, page]);

  const headers = {
    name: "Nome",
    type: "Tipo de Categoria",
  };
  const handleFilterChange = (newFilters: Partial<TableFiltersState>) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      ...newFilters,
    }));
  };
  return (
    <Suspense fallback={<Loading />}>
      <div className="table-section">
        <TableFilters
          dashboardHeader="Categorias"
          tableData={categories}
          placeholder="Digite o nome da categoria."
          statusOptions={{}}
          newItemLabel="Nova Categoria"
          onNewItemClick={() =>
            setAction({ eventName: "create", data: undefined })
          }
          onSearch={handleFilterChange}
          entity="renters"
        />

        <GenericTable
          headers={headers}
          data={categories}
          entity="puchase-category"
          renders={{
            type: (type) => (type == "in" ? "Entrada" : "Saída"),
          }}
        />

        {isLoading && <Loading />}

        <TableFooter
          page={page || 1}
          totalItems={data.totalItems || 0}
          itemsPerPage={data.itemsPerPage || 10}
          goToPage={setPage}
        />
      </div>
      {isAction("create") && <ModalCreateCategory onClose={cleanActionData} />}
    </Suspense>
  );
}

export default TableCategory;
